let total_accounts = 0
let temp = 100
let check_multi_image = false
let total_multi_image_records = 0
$(".multi-choice-image-answers").sortable({ cancel: ".crop-image-modal" })

$(document).ready(function () {
  influence_visual_feedback_and_mandatory_correct_for_interactive_page({
    fieldNeutral: "#multi_choice_image_page_neutral",
    fieldVisualFeedback: "#multi_choice_image_page_visual_feedback",
    fieldMandatoryCorrect: "#multi_choice_image_page_mandatory_correct",
  })

  if (document.getElementById("multi_choice_image_page_multi_choice") == undefined) {
    return
  }

  if ($("#multi_choice_image_page_multi_choice").is(":checked")) {
    check_multi_image = true
    $(".multi-choice-image-answers").find('input[type="checkbox"]').off("click", check_box_image_click_listener)
  } else {
    check_multi_image = false
    $(".multi-choice-image-answers").find('input[type="checkbox"]').on("click", check_box_image_click_listener)
  }

  if (document.getElementById("new_multi_choice_image_page") == undefined) {
    total_multi_image_records = $(".multi-choice-image-answers").children().length / 2
  }

  document.getElementById("multi_choice_image_page_multi_choice").addEventListener("click", function () {
    check_multi_image = this.checked
    if (check_multi_image) {
      $(".multi-choice-image-answers").find('input[type="checkbox"]').off("click", check_box_image_click_listener)
    } else {
      $(".multi-choice-image-answers").find('input[type="checkbox"]').on("click", check_box_image_click_listener)
      check_box_image_click_listener()
    }
  })
  image_preview()

  $("#multi-image").click(function (event) {
    check_last_image_answer()
  })

  $(document).on("click", ".add-multi-image-answer", function (e) {
    e.preventDefault()
    const $link = $(this)
    const useAssetLibrary = $link.data("use-asset-library")
    const fields = $("#fields_data_" + $("#page_language_selection").val()).val()

    if (useAssetLibrary) {
      window.multiImageFieldsData = fields
      window.useAssetLibrary = true
      window.multiImageAssociation = $link.data("association")
      window.multiImageView = $link.data("view")
    } else {
      window.multiImageFieldsData = null
      window.useAssetLibrary = false
      window.multiImageAssociation = null
      window.multiImageView = null

      image_preview()
    }
    return false
  })
})

function image_preview() {
  let language = $("#page_language_selection").val()
  let file_preview = $(".answers-for-" + language)
    .children()
    .last()
    .find(".upload-preview-multi-image img")
  let file_name = $(".answers-for-" + language)
    .children()
    .last()
    .find("#file_name")
  let file_type = $(".answers-for-" + language)
    .children()
    .last()
    .find("#file_type")

  const useAssetLibrary = $(".answers-for-" + language)
    .children()
    .last()
    .find(".add-answer-container")
    .data("use-asset-library")
  if (!useAssetLibrary) {
    const fileInput = $(".answers-for-" + language)
      .children()
      .last()
      .find(".img-preview")

    fileInput.off("change")

    fileInput.change(function (event) {
      let file, input, reader
      $(".answers-for-" + language)
        .children()
        .last()
        .find(".upload-preview-multi-image")
        .css("display", "block")
      $(".answers-for-" + language)
        .children()
        .last()
        .css("display", "block")
      input = $(event.currentTarget)
      file = input[0].files[0]

      const raw_multi_choice_image_answer_file_limits = $("#multi_choice_image_answer_file_limits").val()
      const multi_choice_image_answer_file_limits = JSON.parse(raw_multi_choice_image_answer_file_limits)

      if (fileSizeNotInLimit(file, event, ".edit-banner-modal", multi_choice_image_answer_file_limits["answer"])) {
        input.val("")
        check_last_image_answer()
        return
      } else {
        reader = new FileReader()
        reader.onload = function (e) {
          let image_base64
          image_base64 = e.target.result
          file_preview.attr("src", image_base64)

          make_cropbox()
          $(file_name).val(file.name)
          $(file_type).val(file.type)
        }
        reader.readAsDataURL(file)
      }
    })

    if ($("#asset_library_allowed").val() == "false") {
      fileInput.click()
    }
  }
}

window.remove_multi_image_fields = function (link) {
  $(link).parent().parent().parent().hide()
  $(link).parent().parent().find(".upload-preview-multi-image img").attr("src", "null")
  total_multi_image_records--
}

function check_last_image_answer() {
  let language = $("#page_language_selection").val()
  const lastAnswer = $(".answers-for-" + language).children().last()
  const isExistingAnswer = lastAnswer.find("[name='answer-id']").length > 0
  if (!isExistingAnswer && lastAnswer.find(".img-preview").val() == "") {
    lastAnswer.remove()
    if (total_multi_image_records > 0) {
      total_multi_image_records--
    }
  }
}

window.add_multi_image_fields = function (link, association, fields_to_clone, view) {
  if (!window.useAssetLibrary) {
    check_last_image_answer()
  }

  const $link = $(link)

  if (window.useAssetLibrary) {
    association = window.multiImageAssociation || association
    view = window.multiImageView || view
    fields_to_clone = window.multiImageFieldsData
  }

  const useAssetLibrary =
    window.useAssetLibrary || $link.data("use-asset-library") || $link.closest(".add-answer-container").length > 0

  // Try to get fields data in this order:
  // 1. From the passed fields_to_clone parameter
  // 2. From the stored global variable (only if using asset library)
  // 3. From the hidden input field
  // 4. From the container's data attribute
  if (!fields_to_clone) {
    fields_to_clone =
      window.multiImageFieldsData ||
      $("#fields_data_" + $("#page_language_selection").val()).val() ||
      $link.closest(".fields-data-container").data("fields") ||
      $link.data("fields")
  }

  if (!fields_to_clone) {
    return
  }

  if (total_multi_image_records < 8) {
    total_multi_image_records++
  } else {
  }

  if (view == "new") {
    total_accounts++
  } else {
    temp++
    total_accounts = temp
  }

  let div = document.getElementById("editCropMultiImageModal")
  if (div !== null) {
    div.parentNode.removeChild(div)
  }

  let regexp = new RegExp("new_" + association, "g")
  let regexp2 = new RegExp("new_alt_text", "g")
  let language = $("#page_language_selection").val()
  let course_default_language = $("#course_default_language").val()
  let add_answer =
    course_default_language == language ||
    $(".answers-for-" + language)
      .children()
      .find(".add_answer").length <
      $(".answers-for-" + course_default_language)
        .children()
        .find(".add_answer").length

  if (add_answer) {
    try {
      let replacedFields = fields_to_clone
      let regexp = new RegExp(`\\[new_${association}\\]`, "g")
      replacedFields = replacedFields.replace(regexp, `[${total_accounts}]`)

      let checkboxIdRegex = new RegExp(
        "multi_choice_image_page_multi_choice_image_answers_attributes_new_multi_choice_image_answers_correct",
        "g",
      )
      replacedFields = replacedFields.replace(
        checkboxIdRegex,
        `multi_choice_image_page_multi_choice_image_answers_attributes_${total_accounts}_correct`,
      )

      $(".answers-for-" + language).append(replacedFields.replace(regexp2, total_accounts))

      if (!useAssetLibrary) {
        image_preview()
      } else {
        const lastAnswer = $(".answers-for-" + language)
          .children()
          .last()
        lastAnswer.find(".upload-preview-multi-image").css("display", "block")
        lastAnswer.css("display", "block")
      }
    } catch (e) {
      console.error("Error adding new answer fields:", e)
    }
  } else {
    alert("Can't add more answers in this language as it exceeds the number of answers added in default language")
  }

  if (!useAssetLibrary) {
    window.multiImageFieldsData = null
    window.useAssetLibrary = null
    window.multiImageAssociation = null
    window.multiImageView = null
  }
}

function check_box_image_click_listener() {
  let language = $("#page_language_selection").val()
  let checkboxes = $(".answers-for-" + language).find('input[type="checkbox"]')
  for (let i = 0; checkboxes[i]; i++) {
    if (this != checkboxes[i]) {
      checkboxes[i].checked = false
    }
  }
}

function make_cropbox() {
  let cropbox, croppie_ipad_multi
  cropbox = "#multi_edit_image_cropbox"
  let language = $("#page_language_selection").val()
  $(cropbox).attr(
    "src",
    $(".answers-for-" + language)
      .children()
      .last()
      .find(".upload-preview-multi-image img")
      .attr("src"),
  )

  $(".upload-preview").removeClass("upload-preview")
  $(".answers-for-" + language)
    .children()
    .last()
    .find(".upload-preview-multi-image")
    .addClass("upload-preview")
  $("#editCropMultiImageModal").find(".upload-preview-multi-image").addClass("upload-preview")
  $("#editCropMultiImageModal").find(".upload-preview-multi-image").attr("src", $(cropbox).attr("src"))

  croppie_ipad_multi = $(".croppie-ipad-multi").croppie({
    viewport: {
      width: 400,
      height: 400,
    },
  })

  $("#editCropMultiImageModal").openModal()
  $(".back-crop-multi-image-page").click(function () {
    let modal = $(this).attr("href")
    $(".darkroom-image-container").remove()
    $(modal).closeModal()
  })

  $(".save-cropped-image-btn").click(function () {
    const src = croppie_ipad_multi.get(0).src
    let format = croppie_ipad_multi.get(0).src.split(";")[0].split("/")[1]
    if (!format) {
      format = "jpeg"
    }
    croppie_ipad_multi
      .croppie("result", {
        type: "canvas",
        size: "original",
        format: format,
        quality: "0.99",
      })
      .then(function (response) {
        $(".upload-preview img").attr("src", response)
      })
  })
}

$("#multi_choice_image_page_mandatory_correct").on("click", function () {
  if ($("#multi_choice_image_page_mandatory_correct").is(":checked")) {
    if (!$("#multi_choice_image_page_feedback").is(":checked")) {
      $("#multi_choice_image_page_feedback").click()
    }
    if ($("#multi_choice_image_page_neutral").is(":checked")) {
      $("#multi_choice_image_page_neutral").click()
    }
  }
})

$("#multi_choice_image_page_neutral").on("click", function () {
  influence_visual_feedback_and_mandatory_correct_for_interactive_page({
    fieldNeutral: "#multi_choice_image_page_neutral",
    fieldVisualFeedback: "#multi_choice_image_page_visual_feedback",
    fieldMandatoryCorrect: "#multi_choice_image_page_mandatory_correct",
  })
})

$("#multi_choice_image_page_feedback").on("click", function () {
  if (!$("#multi_choice_image_page_feedback").is(":checked")) {
    if ($("#multi_choice_image_page_mandatory_correct").is(":checked")) {
      $("#multi_choice_image_page_mandatory_correct").click()
    }
  }
})

$('form[id="new_multi_choice_image_page"]').submit(function (e) {
  e.preventDefault()
  disablePageSubmit()
  const asset_library_allowed = $("#asset_library_allowed").val() == "true"

  $("#loading-modal").openModal({ dismissible: false })
  if ($("#multi_choice_image_page_page_attributes_name").val() == "") {
    alert("Name can't be blank")
    enablePageSubmit("Create")
    return false
  }

  let images = []
  let ignore_js = $("#page_convert_to").val() !== ""

  let multi_image_answers = $(".multi-choice-image-answers").children()
  for (let i = 0; multi_image_answers[i]; i++) {
    let correct
    if ($(multi_image_answers[i]).find('input[type="checkbox"]').is(":checked")) {
      correct = 1
    } else {
      correct = 0
    }

    const asset_id = $(multi_image_answers[i]).find(".upload-preview-multi-image").find(".asset_id").val()
    if (
      $(multi_image_answers[i]).find(".upload-preview-multi-image").find("img").attr("src") !== undefined &&
      asset_library_allowed &&
      asset_id
    ) {
      // this is for asset library
      images.push({
        base64: "",
        file_name: "",
        file_type: "",
        language_id: $(multi_image_answers[i]).find("#language_id").val(),
        correct: correct,
        asset_id: asset_id,
        alt_text: $(multi_image_answers[i]).find(".alt_text").val(),
      })
    } else if ($(multi_image_answers[i]).find(".upload-preview-multi-image").find("img").attr("src") !== undefined) {
      // this is for direct upload
      images.push({
        base64: $(multi_image_answers[i])
          .find(".upload-preview-multi-image")
          .find("img")
          .attr("src")
          .replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, ""),
        file_name: $(multi_image_answers[i]).find("#file_name").val(),
        file_type: $(multi_image_answers[i]).find("#file_type").val(),
        language_id: $(multi_image_answers[i]).find("#language_id").val(),
        correct: correct,
        alt_text: $(multi_image_answers[i]).find(".alt_text").val(),
      })
    }
  }

  let feedback, neutral, multi_choice, mandatory_correct, visual_feedback

  if ($("#multi_choice_image_page_feedback").is(":checked")) {
    feedback = 1
  } else {
    feedback = 0
  }
  if ($("#multi_choice_image_page_neutral").is(":checked")) {
    neutral = 1
  } else {
    neutral = 0
  }

  if ($("#multi_choice_image_page_multi_choice").is(":checked")) {
    multi_choice = 1
  } else {
    multi_choice = 0
  }

  if ($("#multi_choice_image_page_mandatory_correct").is(":checked")) {
    mandatory_correct = 1
  } else {
    mandatory_correct = 0
  }

  if ($("#multi_choice_image_page_visual_feedback").is(":checked")) {
    visual_feedback = 1
  } else {
    visual_feedback = 0
  }

  const description_multi = {}
  const ref = $('textarea[id^="multi_choice_image_page_page_attributes_description_multi"]')
  for (let i = 0, len = ref.length; i < len; i++) {
    const answer = ref[i]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = CKEDITOR.instances[id].getData()
    description_multi[key] = val
  }

  const name_multi = {}
  const ref1 = $('input[id^="multi_choice_image_page_page_attributes_name_multi"]')
  for (let j = 0, len1 = ref1.length; j < len1; j++) {
    const answer = ref1[j]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = $(answer).val()
    name_multi[key] = val
  }

  const info_multi = {}
  const ref2 = $('textarea[id^="multi_choice_image_page_page_attributes_info_multi"]')
  for (let k = 0, len2 = ref2.length; k < len2; k++) {
    const answer = ref2[k]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = CKEDITOR.instances[id].getData()
    info_multi[key] = val
  }

  const explanation_multi = {}
  const correct_explanation_multi = {}
  const incorrect_explanation_multi = {}
  const ref3 = $('textarea[id^="multi_choice_image_page_explanation_multi"]')
  for (let k = 0, len3 = ref3.length; k < len3; k++) {
    const answer = ref3[k]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = CKEDITOR.instances[id].getData()
    explanation_multi[key] = val
  }
  const ref4 = $('textarea[id^="multi_choice_image_page_correct_explanation_multi"]')
  for (let k = 0, len4 = ref4.length; k < len4; k++) {
    const answer = ref4[k]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = CKEDITOR.instances[id].getData()
    correct_explanation_multi[key] = val
  }
  const ref5 = $('textarea[id^="multi_choice_image_page_incorrect_explanation_multi"]')
  for (let k = 0, len5 = ref5.length; k < len5; k++) {
    const answer = ref5[k]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = CKEDITOR.instances[id].getData()
    incorrect_explanation_multi[key] = val
  }

  let data = {
    "page[convert_to]": $("#page_convert_to").val(),
    page_to_convert: $("#page_to_convert").val(),
    "multi_choice_image_page[custom_images]": images,
    "multi_choice_image_page[page_attributes][name_multi]": name_multi,
    "multi_choice_image_page[page_attributes][description_multi]": description_multi,
    "multi_choice_image_page[page_attributes][info_multi]": info_multi,
    "multi_choice_image_page[page_attributes][score]": $("#multi_choice_image_page_page_attributes_score").val(),
    "multi_choice_image_page[page_attributes][exclude_from_total_score]": $("#exclude-from-total-score").is(":checked")
      ? "1"
      : "",
    "multi_choice_image_page[page_attributes][status]": $("#multi_choice_image_page_page_attributes_status").val(),
    "multi_choice_image_page[page_attributes][chapter_id]": $(
      "#multi_choice_image_page_page_attributes_chapter_id",
    ).val(),
    "multi_choice_image_page[page_attributes][timeout_in_seconds]": $(
      "#multi_choice_image_page_page_attributes_timeout_in_seconds",
    ).val(),
    "multi_choice_image_page[explanation_multi]": explanation_multi,
    "multi_choice_image_page[correct_explanation_multi]": correct_explanation_multi,
    "multi_choice_image_page[incorrect_explanation_multi]": incorrect_explanation_multi,
    "multi_choice_image_page[multi_choice]": multi_choice,
    authenticity_token: $("input[name=authenticity_token]").val(),
  }

  if ($("#multi_choice_image_page_feedback").length > 0) {
    data["multi_choice_image_page[feedback]"] = feedback
  }

  if ($("#multi_choice_image_page_neutral").length > 0) {
    data["multi_choice_image_page[neutral]"] = neutral
  }

  if ($("#multi_choice_image_page_mandatory_correct").length > 0) {
    data["multi_choice_image_page[mandatory_correct]"] = mandatory_correct
  }

  if ($("#multi_choice_image_page_visual_feedback").length > 0) {
    data["multi_choice_image_page[visual_feedback]"] = visual_feedback
  }

  $.ajax({
    type: "POST",
    url: $(this).attr("action") + ".json",
    enctype: "multipart/form-data",
    data: data,
  })
    .done(function (data, textStatus, jqXHR) {
      if (!ignore_js) {
        window.safeRedirect(data["redirect_to"])
      } else {
        window.safeRedirect(data["convert_to"])
      }
    })
    .fail(function (jqXHR, textStatus, errorThrown) {
      alert(jqXHR.responseText)
      $("input[type='submit']").val("Create")
      $("input[type='submit']").attr("disabled", false)
      $("#loading-modal").closeModal()
    })
  return false
})

$('form[id^="edit_multi_choice_image_page_"]').submit(function (e) {
  e.preventDefault()
  disablePageSubmit()
  $("#loading-modal").openModal({ dismissible: false })
  if ($("#multi_choice_image_page_page_attributes_name").val() == "") {
    alert("Name can't be blank")
    enablePageSubmit("Update")
    return false
  }

  let images = []
  let old_images = []
  let ignore_js = $("#page_convert_to").val() !== ""
  const asset_library_allowed = $("#asset_library_allowed").val() == "true"

  let multi_image_answers = $(".multi-choice-image-answers").children()
  for (let i = 0; multi_image_answers[i]; i++) {
    let correct

    if ($(multi_image_answers[i]).find('input[type="checkbox"]').is(":checked")) {
      correct = 1
    } else {
      correct = 0
    }

    const asset_id = $(multi_image_answers[i]).find(".upload-preview-multi-image").find(".asset_id").val()

    if (
      $(multi_image_answers[i]).find(".upload-preview-multi-image").find("img").attr("src") !== undefined &&
      $(multi_image_answers[i]).find(".upload-preview-multi-image").find("img").attr("src").indexOf("base64") !== -1
    ) {
      images.push({
        base64:
          $(multi_image_answers[i])
            .find(".upload-preview-multi-image")
            .find("img")
            .attr("src")
            .replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "") || "1",
        file_name: $(multi_image_answers[i]).find("#file_name").val(),
        file_type: $(multi_image_answers[i]).find("#file_type").val(),
        language_id: $(multi_image_answers[i]).find("#language_id").val(),
        correct: correct,
        alt_text: $(multi_image_answers[i]).find(".alt_text").val(),
      })
    } else if (
      $(multi_image_answers[i]).find(".upload-preview-multi-image").find("img").attr("src") !== undefined &&
      asset_library_allowed &&
      asset_id
    ) {
      // this is for asset library
      images.push({
        base64: "",
        file_name: "",
        file_type: "",
        language_id: $(multi_image_answers[i]).find("#language_id").val(),
        correct: correct,
        asset_id: asset_id,
        alt_text: $(multi_image_answers[i]).find(".alt_text").val(),
      })
    } else if ($(multi_image_answers[i]).find(".upload-preview-multi-image").find("img").attr("src") !== undefined) {
      old_images.push({
        id: $(multi_image_answers[i]).find("#answer-id").val(),
        language_id: $(multi_image_answers[i]).find("#language_id").val(),
        content: $(multi_image_answers[i]).find(".upload-preview-multi-image").find("img").attr("src"),
        correct: correct,
        alt_text: $(multi_image_answers[i]).find(".alt_text").val(),
      })
    }
  }

  let feedback, neutral, multi_choice, mandatory_correct, visual_feedback

  if ($("#multi_choice_image_page_feedback").is(":checked")) {
    feedback = 1
  } else {
    feedback = 0
  }
  if ($("#multi_choice_image_page_neutral").is(":checked")) {
    neutral = 1
  } else {
    neutral = 0
  }

  if ($("#multi_choice_image_page_multi_choice").is(":checked")) {
    multi_choice = 1
  } else {
    multi_choice = 0
  }

  if ($("#multi_choice_image_page_mandatory_correct").is(":checked")) {
    mandatory_correct = 1
  } else {
    mandatory_correct = 0
  }

  if ($("#multi_choice_image_page_visual_feedback").is(":checked")) {
    visual_feedback = 1
  } else {
    visual_feedback = 0
  }

  const description_multi = {}
  const ref = $('textarea[id^="multi_choice_image_page_page_attributes_description_multi"]')
  for (let i = 0, len = ref.length; i < len; i++) {
    const answer = ref[i]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = CKEDITOR.instances[id].getData()
    description_multi[key] = val
  }

  const name_multi = {}
  const ref1 = $('input[id^="multi_choice_image_page_page_attributes_name_multi"]')
  for (let j = 0, len1 = ref1.length; j < len1; j++) {
    const answer = ref1[j]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = $(answer).val()
    name_multi[key] = val
  }

  const info_multi = {}
  const ref2 = $('textarea[id^="multi_choice_image_page_page_attributes_info_multi"]')
  for (let k = 0, len2 = ref2.length; k < len2; k++) {
    const answer = ref2[k]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = CKEDITOR.instances[id].getData()
    info_multi[key] = val
  }

  const explanation_multi = {}
  const correct_explanation_multi = {}
  const incorrect_explanation_multi = {}
  const ref3 = $('textarea[id^="multi_choice_image_page_explanation_multi"]')
  for (let k = 0, len3 = ref3.length; k < len3; k++) {
    const answer = ref3[k]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = CKEDITOR.instances[id].getData()
    explanation_multi[key] = val
  }
  const ref4 = $('textarea[id^="multi_choice_image_page_correct_explanation_multi"]')
  for (let k = 0, len4 = ref4.length; k < len4; k++) {
    const answer = ref4[k]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = CKEDITOR.instances[id].getData()
    correct_explanation_multi[key] = val
  }
  const ref5 = $('textarea[id^="multi_choice_image_page_incorrect_explanation_multi"]')
  for (let k = 0, len5 = ref5.length; k < len5; k++) {
    const answer = ref5[k]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = CKEDITOR.instances[id].getData()
    incorrect_explanation_multi[key] = val
  }

  let data = {
    "page[convert_to]": $("#page_convert_to").val(),
    page_to_convert: $("#page_to_convert").val(),
    "multi_choice_image_page[custom_images]": images,
    "multi_choice_image_page[old_images]": old_images,
    "multi_choice_image_page[page_attributes][name_multi]": name_multi,
    "multi_choice_image_page[page_attributes][description_multi]": description_multi,
    "multi_choice_image_page[page_attributes][info_multi]": info_multi,
    "multi_choice_image_page[page_attributes][score]": $("#multi_choice_image_page_page_attributes_score").val(),
    "multi_choice_image_page[page_attributes][exclude_from_total_score]": $("#exclude-from-total-score").is(":checked")
      ? "1"
      : "",
    "multi_choice_image_page[page_attributes][status]": $("#multi_choice_image_page_page_attributes_status").val(),
    "multi_choice_image_page[page_attributes][chapter_id]": $(
      "#multi_choice_image_page_page_attributes_chapter_id",
    ).val(),
    "multi_choice_image_page[page_attributes][id]": $("#multi_choice_image_page_page_attributes_id").val(),
    "multi_choice_image_page[page_attributes][timeout_in_seconds]": $(
      "#multi_choice_image_page_page_attributes_timeout_in_seconds",
    ).val(),
    "multi_choice_image_page[explanation_multi]": explanation_multi,
    "multi_choice_image_page[correct_explanation_multi]": correct_explanation_multi,
    "multi_choice_image_page[incorrect_explanation_multi]": incorrect_explanation_multi,
    "multi_choice_image_page[multi_choice]": multi_choice,
    authenticity_token: $("input[name=authenticity_token]").val(),
    _method: "patch",
  }

  if ($("#multi_choice_image_page_feedback").length > 0) {
    data["multi_choice_image_page[feedback]"] = feedback
  }

  if ($("#multi_choice_image_page_neutral").length > 0) {
    data["multi_choice_image_page[neutral]"] = neutral
  }

  if ($("#multi_choice_image_page_mandatory_correct").length > 0) {
    data["multi_choice_image_page[mandatory_correct]"] = mandatory_correct
  }

  if ($("#multi_choice_image_page_visual_feedback").length > 0) {
    data["multi_choice_image_page[visual_feedback]"] = visual_feedback
  }

  $.ajax({
    type: "POST",
    url: $(this).attr("action") + ".json",
    enctype: "multipart/form-data",
    data: data,
  })
    .done(function (data, textStatus, jqXHR) {
      if (!ignore_js) {
        window.safeRedirect(data["redirect_to"])
      } else {
        window.safeRedirect(data["convert_to"])
      }
    })
    .fail(function (jqXHR, textStatus, errorThrown) {
      alert(jqXHR.responseText)
      $("input[type='submit']").val("Update")
      $("input[type='submit']").attr("disabled", false)
      $("#loading-modal").closeModal()
    })
  return false
})

document.addEventListener("assetSelected", function (e) {
  const { url, targetField, id, altText } = e.detail
  let asset_id = id
  if (targetField && targetField.startsWith("multi_choice_image_")) {
    const [_, objectId, languageId] = targetField.split("_")
    const filePreview = $(`.answers-for-${languageId}`).find(
      `[data-object-id="${objectId}"] .upload-preview-multi-image img`,
    )
    const fileName = $(`.answers-for-${languageId}`).find(`[data-object-id="${objectId}"] #file_name`)
    const fileType = $(`.answers-for-${languageId}`).find(`[data-object-id="${objectId}"] #file_type`)
    const assetId = $(`.answers-for-${languageId}`).find(`[data-object-id="${objectId}"] .asset_id`)
    filePreview.attr("src", url)
    assetId.val(asset_id)
    const fileNameFromUrl = url.split("/").pop()
    fileName.val(fileNameFromUrl)
    fileType.val("image/jpeg")
    filePreview.parent().css("display", "block")
    filePreview.parent().parent().parent().css("display", "block")

    // Prefill alt text if available
    if (altText) {
      const answerContainer = $(`.answers-for-${languageId}`).find(`[data-object-id="${objectId}"]`)
      const altTextInput = answerContainer.find(`input.alt_text[name*="multi_choice_image_page_alt_text"][name*="[${languageId}]"]`)
      if (altTextInput.length > 0) {
        altTextInput.val(altText)
      }
    }
  } else if (targetField && targetField.startsWith("new_answer_")) {
    const languageId = targetField.split("_")[2]
    add_multi_image_fields(null, window.multiImageAssociation, window.multiImageFieldsData, "new")
    const lastAnswer = $(".answers-for-" + languageId)
      .children()
      .last()
    const filePreview = lastAnswer.find(".upload-preview-multi-image img")
    const fileName = lastAnswer.find("#file_name")
    const fileType = lastAnswer.find("#file_type")
    const assetId = lastAnswer.find(".asset_id")
    filePreview.attr("src", url)
    assetId.val(asset_id)
    const fileNameFromUrl = url.split("/").pop()
    fileName.val(fileNameFromUrl)
    fileType.val("image/jpeg")
    filePreview.parent().css("display", "block")
    lastAnswer.css("display", "block")

    // Prefill alt text if available
    if (altText) {
      // Find the alt text input in the last answer (for new answers, object_id is replaced with total_accounts)
      const altTextInput = lastAnswer.find(`input.alt_text[name*="multi_choice_image_page_alt_text"][name*="[${languageId}]"]`)
      if (altTextInput.length > 0) {
        altTextInput.val(altText)
      }
    }
  }

  window.multiImageFieldsData = null
  window.useAssetLibrary = null
  window.multiImageAssociation = null
  window.multiImageView = null
  $("input, button, a").prop("disabled", false)
  document.body.offsetHeight
})
